import { render, staticRenderFns } from "./LanguagesSelect.vue?vue&type=template&id=70e939fa&scoped=true"
import script from "./LanguagesSelect.vue?vue&type=script&lang=js"
export * from "./LanguagesSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e939fa",
  null
  
)

export default component.exports